// extracted by mini-css-extract-plugin
var _1 = "Gh02Os8rEZEbrMpcqEKA";
var _2 = "xG1yrHqfnZj0j3miBod6";
var _3 = "DlCIO3diR5MD4Up43PPz";
var _4 = "ffyh3En5xsJVilWwwvVh";
var _5 = "Dh52AWbSsxuqV1BMAs_w";
export { _1 as "bottom", _2 as "center", _3 as "container", _4 as "narrow", _5 as "wide" }
